import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Search from './Search';

const rootElement = document.getElementById('intranet-search-root');
const root = createRoot(rootElement);

root.render(
  <Router>
    <Routes>
      <Route path="*" element={<Search />} />
    </Routes>
  </Router>
);
